import React from "react";

interface ButtonProps {
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  style?: React.CSSProperties;
  title?: string;
}

export default function Button({
  children,
  onClick,
  className,
  type = "button",
  disabled = false,
  style,
  title,
}: ButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`comBtn ${className}`}
      disabled={disabled}
      style={style}
      title={title}
    >
      {children}
    </button>
  );
}
